<template>
    <div class="card">
        <div class="card-header p-2">
            <div class="row">
                <div class="col-md-10">
                    <!-- <strong class="card-title mb-3">{{ 'Users List' }}</strong> -->
                </div>
                <div class="col-md-1">
                    <!-- <download :tableId="'users'" :fileName="'users-list'"></download> -->
                </div>
                <div class="col-md-1">
                    <goback></goback>
                </div>
            </div>
        </div>
        <vue-tabs direction="horizontal" @tab-change="getTabData" active-text-color="black">
            <v-tab title="Strategy">
                <div class="card">
                    <form class="form-horizontal" style="margin-left: 5px;">

                        <div style="display: flex;justify-content: center;margin-top: 8px;">
                            <button type="button" @click="showNewStrategy" class="btn btn-sm mb5 btn-primary"
                                style="padding: 0.2rem;">New Strategy</button>
                        </div>
                        <div v-if="isShow" class="d-flex flex-row border p-2 mt-2 mb-2 strategy-edit">
                            <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New:" : "Edit:"
                                }}</label>
                            <!-- <textarea v-model="editCronQueryData.query_question" name="textarea-input"
                                id="stock-query-txt" rows="3" placeholder="" class="form-control col-sm-10"></textarea> -->
                            <input type="text" class="form-control txt-fmt"
                                v-model="editStrategyMasterData.strategy_title" />
                            <!-- <div class="d-flex align-items-center mr-3 ml-2">
                                <label for="is-used" class="m-0">Is Used: <input type="checkbox"
                                        v-model="editCronQueryData.is_used" name="is-used" style="width: auto;"></label>
                            </div> -->
                            <div class="d-flex align-items-center mr-3 pl-1">
                                <button type="button" @click="submitStrategyMasterData" class="btn btn-sm btn-primary"
                                    style="padding: 0.2rem;">Submit</button>
                            </div>
                        </div>
                        <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
                        <div class="card-body pt-0">
                            <label>Strategy Add/Edit:</label>
                            <div class="d-flex justify-content-start" v-for="(field, index) in strategyMasterData"
                                v-bind:key="'row' + index">
                                <div class="col-md-6 pr-2 pl-0">
                                    <div class="form-group text-end d-flex align-items-center mr-3">
                                        <input type="text" class="form-control txt-fmt" v-model="field.strategy_title"
                                            readonly />
                                        <div class="d-flex align-items-center pl-1">
                                            <a class="btn btn-sm btn-small btn-primary"
                                                @click.prevent="editStrategyMasterDataClick(field)">
                                                <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                            </a>
                                            <a class="btn btn-sm btn-small btn-danger"
                                                @click="removeStrategyMasterData(field)" style="margin: 4px;"><i
                                                    title="Delete Row" class="fa fa-trash cwhite"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </v-tab>
            <v-tab title="Category">
                <div class="card">
                    <form class="form-horizontal" style="margin-left: 5px;">

                        <div style="display: flex;justify-content: center;margin-top: 8px;">
                            <button type="button" @click="showNewCategory" class="btn btn-sm mb5 btn-primary"
                                style="padding: 0.2rem;">New Category</button>
                        </div>
                        <div v-if="isShow" class="d-flex flex-row border p-2 mt-2 mb-2 strategy-edit">
                            <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New:" : "Edit:"
                                }}</label>
                            <input type="text" class="form-control txt-fmt"
                                v-model="editCategoryMasterData.strategy_category" />
                            <div class="d-flex align-items-center mr-3 pl-1">
                                <button type="button" @click="submitCategoryMasterData" class="btn btn-sm btn-primary"
                                    style="padding: 0.2rem;">Submit</button>
                            </div>
                        </div>
                        <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
                        <div class="card-body pt-0">
                            <label>Category Add/Edit:</label>
                            <div class="d-flex justify-content-start" v-for="(field, index) in categoryMasterData"
                                v-bind:key="'row' + index">
                                <div class="col-md-6 pr-2 pl-0">
                                    <div class="form-group text-end d-flex align-items-center mr-3">
                                        <input type="text" class="form-control txt-fmt"
                                            v-model="field.strategy_category" readonly />
                                        <div class="d-flex align-items-center pl-1">
                                            <a class="btn btn-sm btn-small btn-primary"
                                                @click.prevent="editCategoryMasterDataClick(field)">
                                                <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                            </a>
                                            <a class="btn btn-sm btn-small btn-danger"
                                                @click="removeCategoryMasterData(field)" style="margin: 4px;"><i
                                                    title="Delete Row" class="fa fa-trash cwhite"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </v-tab>
            <v-tab title="Response Title">
                <div class="card">
                    <form class="form-horizontal" style="margin-left: 5px;">

                        <div style="display: flex;justify-content: center;margin-top: 8px;">
                            <button type="button" @click="showNewResponseTitle" class="btn btn-sm mb5 btn-primary"
                                style="padding: 0.2rem;">New Response Title</button>
                        </div>
                        <div v-if="isShow" class="d-flex flex-row border p-2 mt-2 mb-2 strategy-edit">
                            <div class="col-md-12">
                                <div>
                                    <label for="stock-query-txt" class="col-form-label mr-2 bold">{{ isNew ? 'New' :
                                        'Edit'
                                        }} Response Title</label>
                                </div>
                                <div class="d-flex align-items-center">
                                    Title: <input type="text" class="form-control txt-fmt mr-1 ml-1"
                                        v-model="editResponseTitleMasterData.response_title" />
                                    Value: <input type="text" class="form-control txt-fmt ml-1"
                                        v-model="editResponseTitleMasterData.value" />
                                    <div class="d-flex align-items-center mr-3 pl-1">
                                        <button type="button" @click="submitResponseTitleMasterData"
                                            class="btn btn-sm btn-primary" style="padding: 0.2rem;">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
                        <div class="card-body pt-0">
                            <label>Response Title: Add/Edit:</label>
                            <div class="d-flex justify-content-start" v-for="(field, index) in responseTitleMasterData"
                                v-bind:key="'row' + index">
                                <div class="col-md-6 pr-2 pl-0">
                                    <div class="form-group text-end d-flex align-items-center mr-3">
                                        Title: <input type="text" class="form-control txt-fmt ml-1"
                                            v-model="field.response_title" readonly />
                                    </div>
                                </div>
                                <div class="col-md-6 pr-2 pl-0">
                                    <div class="form-group text-end d-flex align-items-center mr-3">
                                        Value: <input type="text" class="form-control txt-fmt ml-1"
                                            v-model="field.value" readonly />
                                        <div class="d-flex align-items-center pl-1">
                                            <a class="btn btn-sm btn-small btn-primary"
                                                @click.prevent="editResponseTitleMasterDataClick(field)">
                                                <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                            </a>
                                            <a class="btn btn-sm btn-small btn-danger"
                                                @click="removeResponseTitleMasterData(field)" style="margin: 4px;"><i
                                                    title="Delete Row" class="fa fa-trash cwhite"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </v-tab>
            <v-tab title="Question Type">
                <div class="card">
                    <form class="form-horizontal" style="margin-left: 5px;">

                        <div style="display: flex;justify-content: center;margin-top: 8px;">
                            <button type="button" @click="showNewQuestionType" class="btn btn-sm mb5 btn-primary"
                                style="padding: 0.2rem;">New Question Type</button>
                        </div>
                        <div v-if="isShow" class="d-flex flex-row border p-2 mt-2 mb-2 strategy-edit">
                            <div class="col-md-12 pl-1 pr-1">
                                <div>
                                    <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New" : "Edit"
                                        }} Question Type</label>
                                </div>
                                <div class="d-flex align-items-center">
                                    Type: <input type="text" class="form-control txt-fmt mr-2 ml-1"
                                        v-model="editQuestionTypeMasterData.question_type" />
                                    List: <v-select multiple push-tags :options="responseTitleMasterData"
                                        :placeholder="'Select Response Title'" :label="'response_title'"
                                        v-model="editQuestionTypeMasterData.response_list"
                                        :reduce="(option) => option.response_title">
                                    </v-select>
                                    <div class="d-flex align-items-center mr-3 pl-1">
                                        <button type="button" @click="submitQuestionTypeMasterData"
                                            class="btn btn-sm btn-primary" style="padding: 0.2rem;">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
                        <div class="card-body pt-0">
                            <!-- <label>Question Type: Add/Edit:</label> -->
                            <div class="d-flex justify-content-start" v-for="(field, index) in questionTypeMasterData"
                                v-bind:key="'row' + index">
                                <div class="col-md-12 pr-2 pl-0 d-flex justify-content-start">

                                    <div class="col-md-6 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Question Type:<input type="text" class="form-control txt-fmt"
                                                v-model="field.question_type" readonly />
                                        </div>
                                    </div>
                                    <div class="col-md-5 pr-2 pl-0 ml-2">
                                        <div class="form-group d-flex align-items-center flex-wrap"
                                            v-if="field.response_list.length > 0">
                                            Response list:<div class="sel-tag-main">
                                                <span class="selected-tag"
                                                    v-for="(resListItem, index2) in field.response_list"
                                                    :key="'selTag' + index2">{{ resListItem.response_title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center pl-1">
                                        <a class="btn btn-sm btn-small btn-primary"
                                            @click.prevent="editQuestionTypeMasterDataClick(field)">
                                            <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                        </a>
                                        <a class="btn btn-sm btn-small btn-danger"
                                            @click="removeQuestionTypeMasterData(field)" style="margin: 4px;"><i
                                                title="Delete Row" class="fa fa-trash cwhite"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </v-tab>
            <v-tab title="Strategy Benchmark">
                <div class="card txt-fmt" id="strategyBenchmark">
                    <div style="text-align: right;" class="pr-4 pt-1">
                        <div class="btn btn-primary btn-sm text-end" style="width: fit-content;"
                            @click="getStrategyBenchmarkMasterData"><i title="Reload Data" class="fa fa-refresh"></i>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <label></label>
                        <form class="form-horizontal form-cs" @onsubmit.prevent action>
                            <div v-if="retirementFormData.length > 0"
                                v-for="(row, index) in strategyBenchmarkMasterData[0].data" v-bind:key="'row' + index"
                                class="d-flex justify-content-start align-items-center flex-wrap">
                                <div class="col-md-3 pr-2 pl-0">
                                    <div class="form-group text-end d-flex align-items-center flex-wrap">
                                        Title:<input type="text" class="form-control txt-fmt ml-1"
                                            v-model="row.title" />
                                    </div>
                                </div>
                                <div class="col-md-3 pr-2 pl-0">
                                    <div class="form-group d-flex align-items-center flex-wrap">
                                        Answer:<input type="text" class="form-control txt-fmt ml-1"
                                            v-model="row.answer" />
                                    </div>
                                </div>
                                <div class="col-md-3 pr-2 pl-0">
                                    <div class="form-group d-flex align-items-center flex-wrap">
                                        User Field:<v-select :options="retirementFormData[0].data"
                                            :placeholder="'Strategy Title'" :label="'title'" :value="row.user_field"
                                            v-model="row.user_field" :reduce="(option) => option.title">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-2 pr-2 pl-0">
                                    <div class="form-group d-flex align-items-center flex-wrap">
                                        Calc Formula:<v-select :options="calculationFormulaData"
                                            :placeholder="'Calc Formula'" v-model="row.calculation_formula">
                                        </v-select>
                                    </div>
                                </div>
                                <span><a class="btn btn-sm btn-small btn-danger" style="margin: 4px 4px;"
                                        @click="removeStrategyBenchmarkMasterDataHandler(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a></span>
                            </div>
                            <div class="form-group d-flex justify-content-between">
                                <button class="btn btn-sm btn-success" type="button"
                                    @click="addStrategyBenchmarkMasterDataHandler"><i class="fa fa-plus"></i>
                                    Add</button>
                                <button type="button" class="btn btn-info"
                                    @click="submitStrategyBenchmarkMasterData">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- <DeleteConfirm :show.sync="showDelDialog" ref="deleteDialogModal" :cancelClass="'btn btn-secondary'"
                    @cancel="cancelBenchmarkRecord" @ok="okBenchmarkRecord" :selIndex="selIndex"></DeleteConfirm> -->
            </v-tab>
            <v-tab title="Strategy Form">
                <div class="card txt-fmt">
                    <div style="text-align: right;" class="pr-4 pt-1">
                        <div class="btn btn-primary btn-sm text-end" style="width: fit-content;"
                            @click="reloadRetirementFund"><i title="Reload Data" class="fa fa-refresh"></i></div>
                    </div>
                    <div class="card-body pt-0">
                        <label></label>
                        <form class="form-horizontal form-cs" @onsubmit.prevent action>
                            <div v-if="retirementFormData.length > 0" v-for="(row, index) in retirementFormData[0].data"
                                v-bind:key="'row' + index" class="d-flex justify-content-start">
                                <div class="col-md-6 pr-2 pl-0">
                                    <div class="form-group text-end d-flex align-items-center">
                                        Title:<input type="text" class="form-control txt-fmt ml-1"
                                            v-model="row.title" />
                                    </div>
                                </div>
                                <span><a class="btn btn-sm btn-small btn-danger" style="margin: 4px 4px;"
                                        @click="removeRowDataHandler(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a></span>
                            </div>

                            <div class="form-group d-flex justify-content-between">
                                <button class="btn btn-sm btn-success" type="button"
                                    @click="addStrategyFormDataHandler"><i class="fa fa-plus"></i> Add</button>
                                <button type="button" class="btn btn-info"
                                    @click="submitStrategyFormData">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Conversations Form">

                <div class="card txt-fmt" id="conversationForm">
                    <form class="form-horizontal form-cs" @onsubmit.prevent action>
                        <div>
                            <div class="d-flex justify-content-start mt-3">

                                <div class="col-md-6">
                                    <div class="form-group d-flex align-items-center flex-wrap">
                                        Strategy Title:<v-select :options="strategyMasterData"
                                            :placeholder="'Strategy Title'" label="strategy_title"
                                            v-model="selectedStrategyTitleItem"
                                            :reduce="option => option.strategy_title"
                                            @input="updateStrategyTitleKeyValue($event)">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group d-flex align-items-center flex-wrap">
                                        Select Category:<v-select :options="categoryMasterData"
                                            :placeholder="'Category'" label="strategy_category"
                                            v-model="selectedCategoryItem" :reduce="option => option.strategy_category"
                                            @input="updateStrategyCategoryKeyValue($event)">
                                        </v-select>
                                    </div>
                                </div>
                            </div>

                            <hr style="height:2px;border-width:0;color:gray;background-color:gray;margin-top:0;" />

                            <div class="">
                                <div class="col-md-12 pr-2 pl-0 d-flex justify-content-start"
                                    v-for="(row, index) in strategyQueObject.data">
                                    <div class="col-md-4">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Title:<input type="text" class="form-control txt-fmt" v-model="row.title" />
                                            <span class="error" v-if="row.title == null || row.title == ''">
                                                The title should not be empty!
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-4 pl-0">
                                        <div class="form-group d-flex align-items-center flex-wrap">
                                            Type:<v-select :options="questionTypeMasterData" :placeholder="'Type'"
                                                :label="'question_type'" v-model="row.type"
                                                :create-option="typeObj => ({ type: typeObj.question_type, response_list: typeObj.response_list })"
                                                :reduce="typeObj => `${typeObj.question_type} ${typeObj.response_list}`">
                                            </v-select>
                                            <span class="error" v-if="row.type == null || row.type == ''">
                                                The type should not be empty!
                                            </span>
                                        </div>

                                    </div>
                                    <div class="col-md-4 pl-0" style="margin-right: -0.7rem !important;">
                                        <div class="form-group d-flex align-items-center flex-wrap">
                                            Strategy Benchmark:<v-select
                                                :disabled="row.type.question_type ? row.type.question_type == 'input' : row.type == 'input'"
                                                multiple push-tags :options="strategyBenchmarkMasterData[0].data"
                                                :placeholder="'Strategy Benchmark'" :label="'title'"
                                                v-model="row.strategy_benchmark" :reduce="(option) => option">
                                            </v-select>
                                        </div>
                                    </div>
                                    <span class="mt-4"><a class="btn btn-sm btn-small btn-danger"
                                            style="margin: 4px 4px;" @click="removeStrategyQueRowDataHandler(index)"><i
                                                title="Delete Row" class="fa fa-trash cwhite"></i></a></span>
                                </div>
                            </div>


                            <div class="form-group d-flex justify-content-between pl-3">
                                <button class="btn btn-sm btn-success" type="button"
                                    @click="addConversationsFormData"><i class="fa fa-plus"></i>
                                    Add</button>
                                <button type="button" class="btn btn-info" @click="submitConversationsFormData"
                                    :disabled="!selectedStrategyTitleItem || !selectedCategoryItem || strategyQueObject.data.length == 0">Submit</button>
                            </div>
                        </div>
                    </form>

                </div>
            </v-tab>
            <v-tab title="Hubble-Grable Investor Risk Profiling">
                <div class="card txt-fmt" id="investorRiskProfiling">
                    <form class="form-horizontal" style="margin-left: 5px;">

                        <div style="display: flex;justify-content: center;margin-top: 8px;">
                            <button type="button" @click="showNewInvestorProfilingMasterData"
                                class="btn btn-sm mb5 btn-primary" style="padding: 0.2rem;">New Question Type</button>
                        </div>
                        <div v-if="isShow" class="d-flex flex-row align-items-center border p-2 mt-2 mb-2 strategy-edit"
                            style="padding-bottom: 0 !important;">
                            <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New:" : "Edit:"
                                }}</label>
                            <!-- NEW -->
                            <div
                                class="col-md-2 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Risk Need:<v-select :options="riskNeedOpt" :placeholder="'Risk Need'"
                                    v-model="editInvestorRiskProfilingMasterData.risk_need">
                                </v-select>
                            </div>

                            <div
                                class="col-md-2 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Risk Taking:<v-select :options="riskTakingAbilityOpt" :placeholder="'Risk Taking'"
                                    v-model="editInvestorRiskProfilingMasterData.risk_taking_ability">
                                </v-select>
                            </div>

                            <div
                                class="col-md-2 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Behavioral Loss Tolerance:<v-select append-to-body :options="behavioralLossToleranceOpt"
                                    :placeholder="'Behavioral Loss Tolerance'"
                                    v-model="editInvestorRiskProfilingMasterData.behavioral_loss_tolerance">
                                </v-select>
                            </div>
                            <div
                                class="col-md-2 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">

                                Green/Yellow/Red Light :<v-select :options="green_yellow_red_lightOpt"
                                    :placeholder="'Green/Yellow/Red Light'"
                                    v-model="editInvestorRiskProfilingMasterData.green_yellow_red_light">
                                </v-select>
                            </div>
                            <div class="col-md-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Recommendation:<!-- <input type="text" class="form-control txt-fmt"
                                    v-model="editInvestorRiskProfilingMasterData.recommendation" /> -->
                                <textarea v-model="editInvestorRiskProfilingMasterData.recommendation" rows="2"
                                    cols="50" placeholder="" class="txt-area"></textarea>
                            </div>


                            <div class="col-md-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Strategy:<!-- <input type="text" class="form-control txt-fmt"
                                    v-model="editInvestorRiskProfilingMasterData.strategy" /> -->
                                <textarea v-model="editInvestorRiskProfilingMasterData.strategy" rows="2" cols="50"
                                    placeholder="" class="txt-area"></textarea>
                            </div>

                            <!-- NEW -->
                            <div class="d-flex align-items-center mr-3 pl-1">
                                <button type="button" @click="submitInvestorRiskProfilingMasterData"
                                    class="btn btn-sm btn-primary" style="padding: 0.2rem;">Submit</button>
                            </div>
                        </div>
                        <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
                        <div class="card-body pt-0">
                            <div class="d-flex justify-content-start flex-wrap">
                                <div class="col-md-12 pr-2 pl-0 d-flex justify-content-start"
                                    v-for="(row, index) in investorRiskProfilingMasterData"
                                    v-bind:key="'invest' + index">
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Risk Need:<v-select :options="riskNeedOpt" :placeholder="'Risk Need'"
                                                v-model="row.risk_need">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Risk Taking:<v-select :options="riskTakingAbilityOpt"
                                                :placeholder="'Risk Taking'" v-model="row.risk_taking_ability">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Behavioral Loss Tolerance:<v-select :options="behavioralLossToleranceOpt"
                                                :placeholder="'Behavioral Loss Tolerance'"
                                                v-model="row.behavioral_loss_tolerance">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Green/Yellow/Red Light :<v-select :options="green_yellow_red_lightOpt"
                                                :placeholder="'Green/Yellow/Red Light'"
                                                v-model="row.green_yellow_red_light">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Recommendation:<!-- <input type="text" class="form-control txt-fmt"
                                                v-model="row.recommendation" /> -->
                                            <textarea v-model="row.recommendation" rows="2" cols="50" placeholder=""
                                                class="txt-area"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Strategy:<!-- <input type="text" class="form-control txt-fmt"
                                                v-model="row.strategy" /> -->
                                            <textarea v-model="row.strategy" rows="2" cols="50" placeholder=""
                                                class="txt-area"></textarea>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center pl-1"
                                        style="margin-left: -0.45rem !important;">
                                        <a class="btn btn-sm btn-small btn-primary" style="margin: 4px;"
                                            @click.prevent="editInvestorRiskProfilingMasterClick(row)">
                                            <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                        </a>
                                        <a class="btn btn-sm btn-small btn-danger"
                                            @click="removeInvestorRiskProfilingMasterData(row)" style="margin: 4px;"><i
                                                title="Delete Row" class="fa fa-trash cwhite"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </v-tab>
            <v-tab title="Your First Investment">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Experience (since your first investment)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getFirstInvestmentAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="firstInvestmentTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in firstInvestmentLblData" :key="index"
                                        :style="[item.field !== 'financial_instrument_type' && item.field !== 'product_knowledge' ? { 'width': '15%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in firstInvestmentTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in firstInvestmentLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'financial_instrument_type'" class="new-tbl-cs"
                                            type="text" v-model="key[itemLbl.field]"></input>
                                        <v-select v-else-if="itemLbl.field == 'product_knowledge'"
                                            :options="['Yes', 'No']" :placeholder="'Product Knowledge'"
                                            v-model="key[itemLbl.field]" style="margin-left:0;">
                                        </v-select>
                                        <input v-else class="new-tbl-cs" type="number" v-model="key[itemLbl.field]"
                                            disabled></input>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeFirstInvestmentData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addFirstInvestmentData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitFirstInvestmentAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Interpretation Of Results">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Interpretation of Results
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getInterpretationResultAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="interpretationResultTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in interpretationResultLblData" :key="index">{{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in interpretationResultTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in interpretationResultLblData" :key="subIdx">
                                        <textarea v-if="itemLbl.field == 'descriptions'" v-model="key[itemLbl.field]"
                                            rows="3" cols="50" placeholder="" class="txt-area"></textarea>
                                        <input v-else class="new-tbl-cs" type="text"
                                            v-model="key[itemLbl.field]"></input>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeInterpretationResultData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addInterpretationResultData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitInterpretationResultAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Assumptions & Asset Allocation Framework">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Assumptions & Asset Allocation (AAA) Framework
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAAFrameworkAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaFrameworkTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaFrameworkLblData" :key="index"
                                        :style="[item.field === 'input_value' ? { 'width': '12%' } : item.field === 'sub_category' ? { 'width': '40%' } : item.field === 'S_No' ? { 'width': '10%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaFrameworkTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaFrameworkLblData" :key="subIdx">
                                        <div v-if="itemLbl.field == 'sub_category' || itemLbl.field == 'input_value'"
                                            class="">
                                            <div v-for="(subCatItem, cIdx) in key.data" class="d-flex">
                                                <input class="new-tbl-aaa-cs" :key="cIdx"
                                                    v-model="subCatItem[itemLbl.field]" />
                                                <div v-if="itemLbl.field == 'sub_category'"
                                                    @click="removeSubCategoryData(key.data, cIdx)">
                                                    <a class="btn btn-sm btn-small btn-danger mt-2"
                                                        style="margin: 4px 4px;"><i title="Delete Row"
                                                            class="fa fa-trash cwhite"></i></a>
                                                </div>
                                            </div>
                                            <div>
                                                <button v-if="itemLbl.field == 'sub_category'" class="btn-success"
                                                    style="border: none;" type="button"
                                                    @click="addSubCategoryData(key.data)"><i
                                                        class="fa fa-plus"></i></button>
                                            </div>
                                        </div>
                                        <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAAFrameworkData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAAFrameworkData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAAAFrameworkAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Asset Allocation Assumptions Time Horizon">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Allocation Assumptions (Based on Time Horizon of Goal)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAATimeHorizonAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaTimeHorizonTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaTimeHorizonLblData" :key="index"
                                        :style="[item.field === 'Description' ? { 'width': '40%' } : item.field === 'Category' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaTimeHorizonTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaTimeHorizonLblData" :key="subIdx">
                                        <!-- <textarea v-if="itemLbl.field == 'Category' || itemLbl.field == 'Description'"
                                            v-model="key[itemLbl.field]" rows="2" class="txt-area" style="width: 100%;"></textarea> -->
                                        <input v-if="itemLbl.field == 'Category' || itemLbl.field == 'Description'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                        <!-- <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]"
                                            readonly /> -->
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAATimeHorizonData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAATimeHorizonData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAAATimeHorizonAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Asset Allocation Assumptions Risk Profile">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Allocation Assumptions (Based on Risk Profile of Client)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAARiskProfileOfClientAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaRiskProfileOfClientTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaRiskProfileOfClientLblData" :key="index"
                                        :style="[item.field === 'Type_of_Investor' ? { 'width': '40%' } : item.field === 'Risk_Profile' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaRiskProfileOfClientTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaRiskProfileOfClientLblData" :key="subIdx">
                                        <!-- <textarea v-if="itemLbl.field == 'Category' || itemLbl.field == 'Description'"
                                            v-model="key[itemLbl.field]" rows="2" class="txt-area" style="width: 100%;"></textarea> -->
                                        <input
                                            v-if="itemLbl.field == 'Risk_Profile' || itemLbl.field == 'Type_of_Investor'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                        <!-- <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]"
                                            readonly /> -->
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAARiskProfileOfClientData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAARiskProfileOfClientData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitAAARiskProfileOfClientAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Asset Allocation Assumptions Income Generation">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Allocation Assumptions (Income Generation Requirement)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAAIncomeGenerationAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaIncomeGenerationTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaIncomeGenerationLblData" :key="index"
                                        :style="[item.field === 'When' ? { 'width': '40%' } : item.field === 'Type_of_Corpus' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaIncomeGenerationTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaIncomeGenerationLblData" :key="subIdx">
                                        <!-- <textarea v-if="itemLbl.field == 'Category' || itemLbl.field == 'Description'"
                                            v-model="key[itemLbl.field]" rows="2" class="txt-area" style="width: 100%;"></textarea> -->
                                        <input v-if="itemLbl.field == 'Type_of_Corpus' || itemLbl.field == 'When'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                        <!-- <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]"
                                            readonly /> -->
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAAIncomeGenerationData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAAIncomeGenerationData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAAAIncomeGenerationAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Professionals Recommendation to Client">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Professional's Recommendation to Client
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getRecommendationToClientAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaRecommendationToClientTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaRecommendationToClientLblData" :key="index"
                                        :style="[item.field === 'Investment_Portfolio_Name' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaRecommendationToClientTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaRecommendationToClientLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'Investment_Portfolio_Name'" class="new-tbl-cs"
                                            type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeRecommendationToClientData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addRecommendationToClientData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitRecommendationToClientAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
        </vue-tabs>
    </div>

</template>
<script>
import http from "@/lib/http";
//import { commonMixins } from "../../assets/mixins/common.js";
import DeleteConfirm from "@/components/Delete-Confirm.vue";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;

export default {
    props: ["onCreated"],
    components: { DeleteConfirm },
    name: "UserProfilingForm",
    created() {
        console.log("Created ::: edit id", this.$route.params);
        this.getStrategyMasterData();
        //this.getStrategyData();
        //if (this.newTab.title === 'Strategy') {

        //this.retirementFormDataCollection = Array.from(this.retirementFormData);
        //this.retirementFormDataCollection = [...this.retirementFormData];
        //}
    },
    watch: {
        onCreated(flg) {
            console.log('created:', flg);
            this.getStrategyMasterData();
        }
    },
    data() {
        return {
            selIndex: 0,
            showDelDialog: false,
            isNew: false,
            isShow: false,
            calculationFormulaData: ["<", ">", "<=", ">=", "==", "!="],
            editStrategyMasterData: { "strategy_title": "" },
            editCategoryMasterData: { "strategy_category": "" },
            editQuestionTypeMasterData: { "question_type": "", "response_list": [] },
            editResponseTitleMasterData: { "response_title": "" },
            editInvestorRiskProfilingMasterData: {
                "behavioral_loss_tolerance": null,
                "risk_need": null,
                "risk_taking_ability": null,
                "green_yellow_red_light": null,
                "recommendation": "",
                "strategy": ""
            },
            retirementFormData: [{ "data": [] }],
            strategyBenchmarkMasterData: [{ "data": [] }],
            strategyMasterData: [],
            categoryMasterData: [],
            questionTypeMasterData: [],
            responseTitleMasterData: [],
            selectedStrategyQuestionCategory: null,
            strategyQueObject: {
                "strategy_category": "",
                "strategy_title": "",
                "data": []
            },
            errors: [],
            strategyQueChildObj: [{
                "title": "",
                "type": "",
                "answer": "",
                "strategy_benchmark": []
            }],
            selectedStrategyTitleItem: null,
            selectedCategoryItem: null,
            investorRiskProfilingMasterData: [],
            riskNeedOpt: ["High", "Mod", "Low"],
            riskTakingAbilityOpt: ["High", "Mod", "Low"],
            behavioralLossToleranceOpt: ["High", "Mod", "Low"],
            green_yellow_red_lightOpt: ["Green Light", "Yellow Light", "Red Light"],
            firstInvestmentLblData: [{ lbl: "Financial instrument type", field: "financial_instrument_type" },
            { lbl: "Product knowledge", field: "product_knowledge" },
            { lbl: "Date of first investment", field: "date_of_first_investment" },
            { lbl: "Invested amount (INR cr)", field: "invested_amount_INR_cr" },
            { lbl: "Number of transactions", field: "mumber_of_transactions" }],
            firstInvestmentTblData: [],
            interpretationResultLblData: [
                { lbl: "Score", field: "score " },
                { lbl: "Risk Tolerance", field: "risk_tolerance" },
                { lbl: "Client Classification", field: "client_classification" },
                { lbl: "Type of Product", field: "type_of_product" },
                { lbl: "Investor Profile Descriptions", field: "descriptions" }],
            interpretationResultTblData: [],
            aaaFrameworkLblData: [
                { lbl: "S No.", field: "S_No" },
                {
                    lbl: "Assumption", field: "Assumption", child: [{ lbl: "Sub-Category", field: "sub_category" },
                    { lbl: "Figure", field: "input_value" }]
                },
                { lbl: "Sub-Category", field: "sub_category" },
                { lbl: "Figure", field: "input_value" }],
            aaaFrameworkTblData: [],
            aaaTimeHorizonLblData: [
                { lbl: "S No.", field: "S_No" },
                { lbl: "Category", field: "Category" },
                { lbl: "Description", field: "Description" },
                { lbl: "Liquid", field: "Liquid" },
                { lbl: "Debt", field: "Debt" },
                { lbl: "Gold", field: "Gold" },
                { lbl: "Equity", field: "Equity" },
                { lbl: "Total", field: "Total" },
                { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
            ],
            aaaTimeHorizonTblData: [],
            aaaRiskProfileOfClientLblData: [
                { lbl: "S No.", field: "S_No" },
                { lbl: "Type of Investor", field: "Type_of_Investor" },
                { lbl: "Risk Profile", field: "Risk_Profile" },
                { lbl: "Liquid", field: "Liquid" },
                { lbl: "Debt", field: "Debt" },
                { lbl: "Gold", field: "Gold" },
                { lbl: "Equity", field: "Equity" },
                { lbl: "Total", field: "Total" },
                { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
            ],
            aaaRiskProfileOfClientTblData: [],
            aaaIncomeGenerationLblData: [
                { lbl: "S No.", field: "S_No" },
                { lbl: "Type of Corpus", field: "Type_of_Corpus" },
                { lbl: "When", field: "When" },
                { lbl: "Liquid", field: "Liquid" },
                { lbl: "Debt", field: "Debt" },
                { lbl: "Gold", field: "Gold" },
                { lbl: "Equity", field: "Equity" },
                { lbl: "Total", field: "Total" },
                { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
            ],
            aaaIncomeGenerationTblData: [],
            aaaRecommendationToClientLblData: [
                { lbl: "S No.", field: "S_No" },
                { lbl: "Investment Portfolio Name", field: "Investment_Portfolio_Name" },
                { lbl: "Liquid", field: "Liquid" },
                { lbl: "Debt", field: "Debt" },
                { lbl: "Gold", field: "Gold" },
                { lbl: "Equity", field: "Equity" },
                { lbl: "Total", field: "Total" },
                { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
            ],
            aaaRecommendationToClientTblData: [],
        };
    },
    methods: {
        showDelDialogModal(index) {
            this.selIndex = index;
            this.$refs.deleteDialogModal.open();
        },
        Validator() {
            return Validator.create();
        },
        updateStrategyTitleKeyValue(event) {
            console.log('1=> ', this.selectedStrategyTitleItem, this.selectedCategoryItem);
            this.strategyQueObject["strategy_category"] = this.selectedCategoryItem == null ? "" : this.selectedCategoryItem.strategy_category;
            this.strategyQueObject["strategy_title"] = this.selectedStrategyTitleItem == null ? "" : this.selectedStrategyTitleItem.strategy_title;
            this.getConversationsFormData();
        },
        updateStrategyCategoryKeyValue(event) {
            this.strategyQueObject["strategy_category"] = this.selectedCategoryItem == null ? "" : this.selectedCategoryItem.strategy_category;
            this.strategyQueObject["strategy_title"] = this.selectedStrategyTitleItem == null ? "" : this.selectedStrategyTitleItem.strategy_title;
            this.getConversationsFormData();
        },
        addConversationsFormData() {
            this.strategyQueObject.data.push({
                "title": "",
                "type": "",
                "answer": "",
                "strategy_benchmark": []
            });
        },
        submitConversationsFormData() {

            console.log('strategyQueObject   ::', this.strategyQueObject);
            if (this.strategyQueObject["strategy_category"] == "" || this.strategyQueObject["strategy_title"] == "") {
                this.$toastr.error("Please Select `Strategy Title` and `Category` form list", "", {});
                return;
            }
            let notValid = false;
            this.strategyQueObject.data.map((item) => {
                //console.log('###=> ', item.title, item.type)
                if (item.title == "" || item.type == "") {
                    //console.log('Not Valid');
                    notValid = true;
                }
            });
            if (notValid) {
                this.$toastr.error("Please fill the form proper !", "", {});
                return;
            }

            let self = this;
            http.post("/frontend/strategy_question/update", this.strategyQueObject, (error, response) => {
                if (response.responseType === 'success') {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        },
        getStrategyData() {
            let self = this;
            http.get("/frontend/strategy_columns/get?type=super_admin", {}, (error, response) => {
                if (response.status === 'success') {
                    self.retirementFormData = response.data;
                }
            });
        },
        getStrategyMasterData() {
            let self = this;
            http.get("/frontend/strategy/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.strategyMasterData = response.data;
                }
            });
        },
        getCategoryMasterData() {
            let self = this;
            http.get("/frontend/strategy_category/get?type=super_admin", {}, (error, response) => {
                if (response.status === 'success') {
                    self.categoryMasterData = response.data;
                }
            });
        },
        submitCategoryMasterData() {
            let self = this;
            if (this.editCategoryMasterData.strategy_category.trim() === "") {
                this.$toastr.error("Category string not blank", "", {});
            } else {
                http.post("/frontend/strategy_category/update", this.editCategoryMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getCategoryMasterData();
                    }
                    self.editCategoryMasterData = { strategy_category: "" };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        getResponseTitleMasterData() {
            let self = this;
            http.get("/frontend/response_title/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.responseTitleMasterData = response.data;
                }
            });
        },
        selectResponseTitleData() {
            console.log("Get RawData", this.selComp);
            /* if (this.selComp !== "") {
                localStorage.setItem("selcomp", JSON.stringify(this.selComp));
                this.company.companyname = this.selComp.companyname;
                this.company.co_code = this.selComp.co_code;
                console.log(
                    "Company",
                    this.company.co_code,
                    "=>",
                    this.company.companyname
                );
                // this.getTabData(this.selRowInd, {}, {});
                this.getRawData();
            } */
        },
        submitResponseTitleMasterData() {
            let self = this;
            if (this.editResponseTitleMasterData.response_title.trim() === "") {
                this.$toastr.error("Response Title string not blank", "", {});
            } else {
                http.post("/frontend/response_title/update", this.editResponseTitleMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getResponseTitleMasterData();
                    }
                    self.editResponseTitleMasterData = { response_title: "" };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        getQuestionTypeMasterData() {
            let self = this;
            http.get("/frontend/question_type/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.questionTypeMasterData = response.data;
                    self.getResponseTitleMasterData();
                }
            });
        },
        submitQuestionTypeMasterData() {
            let self = this;
            if (this.editQuestionTypeMasterData.question_type.trim() === "") {
                this.$toastr.error("Question title string not blank", "", {});
            } else {
                //console.log('editQuestionTypeMasterData >>> ', this.editQuestionTypeMasterData);
                //return;
                http.post("/frontend/question_type/update", this.editQuestionTypeMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getQuestionTypeMasterData();
                    }
                    self.editQuestionTypeMasterData = { question_type: "", response_list: [] };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addStrategyBenchmarkMasterDataHandler() {
            console.log('this.strategyBenchmarkMasterData[0] >>>', this.strategyBenchmarkMasterData[0]);
            this.strategyBenchmarkMasterData[0].data.push({
                "title": "",
                "type": "input",
                "response_list": [],
                "answer": "",
                "user_field": "",
                "user_field_enterd_valued": "",
                "calculation_formula": ""
            })
        },
        okBenchmarkRecord(id) {
            console.log('okBenchmarkRecord', id);
            this.strategyBenchmarkMasterData[0].data.splice(id, 1);
            //this.submitStrategyBenchmarkMasterData();
        },
        cancelBenchmarkRecord() {
            console.log('cancelBenchmarkRecord');
        },
        removeStrategyBenchmarkMasterDataHandler(idx) {
            //this.showDelDialogModal(idx);
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.strategyBenchmarkMasterData[0].data.splice(idx, 1);
                self.submitStrategyBenchmarkMasterData();
                /* const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/strategy/delete", param, function (error, response) {
                    console.log('strategy/delete: ', response.responseType);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getStrategyMasterData();
                    }
                }); */
            }


        },
        getStrategyBenchmarkMasterData() {
            let self = this;
            http.get("/frontend/strategy_benchmark/get?type=super_admin", {}, (error, response) => {
                if (response.status === 'success') {
                    self.strategyBenchmarkMasterData = response.data;
                    if (response.data.length === 0) {
                        self.strategyBenchmarkMasterData = [{ "data": [] }];
                    }
                    self.getStrategyData();
                }
            });
        },
        submitStrategyBenchmarkMasterData() {
            let self = this;
            console.log('this.strategyBenchmarkMasterData ###', this.strategyBenchmarkMasterData)
            /* "title": "",
            "type": "input",
            "response_list": [],
            "answer": "",
            "user_field": "",
            "user_field_enterd_valued": "",
            "calculation_formula": "" */
            let anyError = false;
            const collectStrategyBenchmarkData = this.strategyBenchmarkMasterData[0].data.map((item) => {
                let collectItemsData = item;
                if (item.title.trim() == "" || item.answer.trim() == "" || item.calculation_formula.trim() == "") {
                    anyError = true;
                }
                //return [{ ...item, user_field: item.user_field.title }];
                collectItemsData.user_field = item.user_field ? item.user_field.title : "";
                return collectItemsData;
            });

            if (anyError) {
                self.$toastr.error("Title, Answer and Calc Formula filed not be blank", "", {});
                return;
            }
            //console.log('collectStrategyBenchmarkData: ', collectStrategyBenchmarkData)
            //return;
            http.post("/frontend/strategy_benchmark/update", this.strategyBenchmarkMasterData[0], function (error, response) {
                console.log(">>>> post data:", response);
                if (response.responseType === "success") {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        },
        //Conversations Form : START
        getConversationsFormData() {
            let self = this;
            if (this.selectedStrategyTitleItem == null || this.selectedCategoryItem == null) {
                self.$toastr.error("Please select Strategy Title and Category form list", "", {});
                return;
            }

            const data = { 'strategy_category': this.selectedCategoryItem.strategy_category, 'strategy_title': this.selectedStrategyTitleItem.strategy_title };

            http.post("/frontend/strategy_question/get?type=super_admin", data, (error, response) => {
                if (response.status === 'success') {

                    if (response.data.length === 0) {
                        self.strategyQueObject = {
                            "strategy_category": this.selectedCategoryItem != null ? this.selectedCategoryItem.strategy_category : "",
                            "strategy_title": this.selectedStrategyTitleItem != null ? this.selectedStrategyTitleItem.strategy_title : "",
                            "data": []
                        };
                    } else {
                        self.strategyQueObject = response.data[0];
                    }
                }
            });
        },
        updateConversationsFormData() {
            let self = this;
            http.post("frontend/strategy_question/update", this.strategyQueObject, function (error, response) {
                console.log(">>>> post data:", response);
                if (response.responseType === "success") {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        },
        //Conversations Form : END
        editStrategyMasterDataClick(param) {
            this.editStrategyMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        },
        removeStrategyMasterData(field) {
            //this.strategyMasterData.splice(idx, 1);
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/strategy/delete", param, function (error, response) {
                    console.log('strategy/delete: ', response.responseType);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getStrategyMasterData();
                    }
                });
            }
        },
        removeCategoryMasterData(field) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/strategy_category/delete", param, function (error, response) {
                    console.log('strategy/delete: ', response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getCategoryMasterData();
                    }
                });
            }
        },
        removeResponseTitleMasterData(field) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/response_title/delete", param, function (error, response) {
                    console.log('ResponseTitle/delete: ', response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getResponseTitleMasterData();
                    }
                });
            }
        },
        removeQuestionTypeMasterData(field) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/question_type/delete", param, function (error, response) {
                    console.log('QuestionTypeMaster/delete: ', response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getQuestionTypeMasterData();
                    }
                });
            }
        },
        removeInvestorRiskProfilingMasterData(field) {
            let self = this;
            console.log('removeInvestorRiskProfilingMaster: ', field._id)
            //return;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/grable_tree_factor_model_of_investor_risk_profile/delete", param, function (error, response) {
                    console.log('InvestorRiskProfilingMaster/delete: ', response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getInvestorRiskProfiling();
                    }
                });
            }
        },
        getInvestorRiskProfiling() {
            let self = this;
            http.get("/frontend/grable_tree_factor_model_of_investor_risk_profile/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.investorRiskProfilingMasterData = response.data;
                    //self.getStrategyData();
                }
            });
        },
        submitInvestorRiskProfilingMasterData() {
            let self = this;
            const obj = this.editInvestorRiskProfilingMasterData;
            if (obj.behavioral_loss_tolerance === "" || obj.behavioral_loss_tolerance == null || obj.risk_need === "" || obj.risk_need == null || obj.risk_taking_ability === "" || obj.risk_taking_ability == null || obj.green_yellow_red_light === "" || obj.green_yellow_red_light == null || obj.recommendation.trim() === "" || obj.strategy.trim() === "") {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitInvestorRiskProfilingMasterData >>> ', obj);
                http.post("/frontend/grable_tree_factor_model_of_investor_risk_profile/update", obj, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getInvestorRiskProfiling();
                    }
                    self.editInvestorRiskProfilingMasterData = {
                        "behavioral_loss_tolerance": null,
                        "risk_need": null,
                        "risk_taking_ability": null,
                        "green_yellow_red_light": null,
                        "recommendation": "",
                        "strategy": ""
                    };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        getFirstInvestmentAPI() {
            let self = this;
            http.get("/frontend/experience_since_your_first_investment_form/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.firstInvestmentTblData = response.data;
                    //self.getStrategyData();
                }
            });
        },
        submitFirstInvestmentAPI() {
            let self = this;
            const obj = this.firstInvestmentTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.financial_instrument_type == "" || item.product_knowledge == "" || item.product_knowledge == null) {
                    notValid = true;
                }
            });
            //console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("Please fill the 'Financial instrument type' and 'Product knowledge' form proper !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitFirstInvestmentAPI >>> ', obj[0]);
                http.post("/frontend/experience_since_your_first_investment_form/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getFirstInvestmentAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addFirstInvestmentData() {
            this.firstInvestmentTblData[0].data.push({
                "financial_instrument_type": "",
                "product_knowledge": null,
                "date_of_first_investment": "",
                "invested_amount_INR_cr": "",
                "mumber_of_transactions": ""
            });
        },

        /* interpretation Result :START */
        getInterpretationResultAPI() {
            let self = this;
            http.get("/frontend/interpretation_of_results/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.interpretationResultTblData = response.data;
                    //self.getStrategyData();
                }
            });
        },
        submitInterpretationResultAPI() {
            let self = this;
            const obj = this.interpretationResultTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item['score '] == "" || item.risk_tolerance == "" || item.client_classification == "" || item.type_of_product == "" || item.descriptions == "") {
                    notValid = true;
                }
            });
            //console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitInterpretationResultAPI >>> ', obj[0]);
                http.post("/frontend/interpretation_of_results/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getInterpretationResultAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addInterpretationResultData() {
            this.interpretationResultTblData[0].data.push({
                "score ": "",
                "risk_tolerance": "",
                "client_classification": "",
                "type_of_product": "",
                "descriptions": ""
            });
        },
        removeInterpretationResultData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.interpretationResultTblData[0].data.splice(idx, 1);
                self.submitInterpretationResultAPI();
            }
        },
        /* interpretation Result :END */

        /* AAA FrameworkAPI : START */
        getAAAFrameworkAPI() {
            let self = this;
            http.get("/frontend/assumptions_asset_allocation_framework/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaFrameworkTblData = response.data;
                }
            });
        },
        submitAAAFrameworkAPI() {
            let self = this;
            const obj = this.aaaFrameworkTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.S_No == "" || item.Assumption == "") {
                    notValid = true;
                }
                item.data.map((childItem) => {
                    if (childItem.sub_category == "") {
                        notValid = true;
                    }
                });
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAAFrameworkAPI >>> ', obj[0]);
                http.post("/frontend/assumptions_asset_allocation_framework/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAAFrameworkAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addSubCategoryData(parent) {
            parent.push({
                "sub_category": "",
                "input_value": ""
            });
        },
        addAAAFrameworkData() {
            this.aaaFrameworkTblData[0].data.push({
                "S_No": this.aaaFrameworkTblData[0].data.length + 1,
                "Assumption": "",
                "data": [
                    {
                        "sub_category": "",
                        "input_value": ""
                    }
                ]
            });
        },
        removeSubCategoryData(parent, idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                parent.splice(idx, 1);
                self.submitAAAFrameworkAPI();
            }
        },
        removeAAAFrameworkData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.aaaFrameworkTblData[0].data.splice(idx, 1);
                self.submitAAAFrameworkAPI();
            }
        },
        /* AAA FrameworkAPI : END */

        /* AAA Time-Horizon-Based : START */
        getAAATimeHorizonAPI() {
            let self = this;
            http.get("/frontend/assest_allocation_assumptions_time_horizon_based/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaTimeHorizonTblData = response.data;
                }
            });
        },
        submitAAATimeHorizonAPI() {
            let self = this;
            const obj = this.aaaTimeHorizonTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Category == "" || item.Description == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAATimeHorizonAPI >>> ', obj[0]);
                //return;
                http.post("/frontend/assest_allocation_assumptions_time_horizon_based/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAATimeHorizonAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAATimeHorizonData() {
            this.aaaTimeHorizonTblData[0].data.push({
                "S_No": this.aaaTimeHorizonTblData[0].data.length + 1,
                "Category": "",
                "Description": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },
        removeAAATimeHorizonData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.aaaTimeHorizonTblData[0].data.splice(idx, 1);
                self.submitAAATimeHorizonAPI();
            }
        },
        /* AAA Time-Horizon-Based : END */

        /* AAA Based-on-Risk-Profile-of-Client : START */
        getAAARiskProfileOfClientAPI() {
            let self = this;
            http.get("/frontend/asset_allocation_assumption_risk_profile_client_based/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaRiskProfileOfClientTblData = response.data;
                }
            });
        },
        submitAAARiskProfileOfClientAPI() {
            let self = this;
            const obj = this.aaaRiskProfileOfClientTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Type_of_Investor == "" || item.Risk_Profile == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAARiskProfileOfClientAPI >>> ', obj[0]);
                //return;  
                http.post("/frontend/asset_allocation_assumption_risk_profile_client_based/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAARiskProfileOfClientAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAARiskProfileOfClientData() {
            this.aaaRiskProfileOfClientTblData[0].data.push({
                "S_No": this.aaaRiskProfileOfClientTblData[0].data.length + 1,
                "Type_of_Investor": "",
                "Risk_Profile": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },
        removeAAARiskProfileOfClientData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.aaaRiskProfileOfClientTblData[0].data.splice(idx, 1);
                self.submitAAARiskProfileOfClientAPI();
            }
        },
        /* AAA Based-on-Risk-Profile-of-Client : END */

        /* AAA Income Generation Requirement : START */
        getAAAIncomeGenerationAPI() {
            let self = this;
            http.get("/frontend/asset_allocation_assumptions_income_generation/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaIncomeGenerationTblData = response.data;
                }
            });
        },
        submitAAAIncomeGenerationAPI() {
            let self = this;
            const obj = this.aaaIncomeGenerationTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Type_of_Corpus == "" || item.When == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAARiskProfileOfClientAPI >>> ', obj[0]);
                //return;  
                http.post("/frontend/asset_allocation_assumptions_income_generation/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAAIncomeGenerationAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAAIncomeGenerationData() {
            this.aaaIncomeGenerationTblData[0].data.push({
                "S_No": this.aaaIncomeGenerationTblData[0].data.length + 1,
                "Type_of_Corpus": "",
                "When": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },

        removeAAAIncomeGenerationData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.aaaIncomeGenerationTblData[0].data.splice(idx, 1);
                self.submitAAAIncomeGenerationAPI();
            }
        },
        /* AAA Income Generation Requirement : END */

        /* Professional's Recommendation to Client : START */
        getRecommendationToClientAPI() {
            let self = this;
            http.get("/frontend/professional_recommendation_to_client/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaRecommendationToClientTblData = response.data;
                }
            });
        },
        submitRecommendationToClientAPI() {
            let self = this;
            const obj = this.aaaRecommendationToClientTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Investment_Portfolio_Name == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitRecommendationToClientAPI >>> ', obj[0]);
                //return;
                http.post("/frontend/professional_recommendation_to_client/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getRecommendationToClientAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addRecommendationToClientData() {
            this.aaaRecommendationToClientTblData[0].data.push({
                "S_No": this.aaaRecommendationToClientTblData[0].data.length + 1,
                "Investment_Portfolio_Name": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },
        removeRecommendationToClientData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.aaaRecommendationToClientTblData[0].data.splice(idx, 1);
                self.submitRecommendationToClientAPI();
            }
        },
        /* Professional's Recommendation to Client : END */

        showNewStrategy() {
            this.editStrategyMasterData = { strategy_title: "" };
            this.isNew = true;
            this.isShow = true;
        },
        showNewCategory() {
            this.editCategoryMasterData = { strategy_category: "" };
            this.isNew = true;
            this.isShow = true;
        },
        showNewQuestionType() {
            this.editQuestionTypeMasterData = { question_type: "", response_list: [] };
            this.isNew = true;
            this.isShow = true;
        },
        showNewResponseTitle() {
            this.editResponseTitleMasterData = { response_title: "" };
            this.isNew = true;
            this.isShow = true;
        },
        showNewInvestorProfilingMasterData() {
            this.editInvestorRiskProfilingMasterData = {
                "behavioral_loss_tolerance": null,
                "risk_need": null,
                "risk_taking_ability": null,
                "green_yellow_red_light": null,
                "recommendation": "",
                "strategy": ""
            };
            this.isNew = true;
            this.isShow = true;
        },
        editCategoryMasterDataClick(param) {
            this.editCategoryMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        },
        editResponseTitleMasterDataClick(param) {
            this.editResponseTitleMasterData = param;
            this.isNew = false;
            this.isShow = true;
        },
        editQuestionTypeMasterDataClick(param) {
            console.log('param', param);
            this.editQuestionTypeMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        },
        editInvestorRiskProfilingMasterClick(param) {
            console.log('param', param);
            this.editInvestorRiskProfilingMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        },
        submit() {
            this.$validate(["firstname", "email"]).then(success => {

            });
        },
        getTabData(tabIndex, newTab, oldTab) {
            console.log('Tab:', tabIndex, newTab.title, oldTab.title);
            /* Strategy
            Category
            Strategy Benchmark
            Strategy Form
            Conversations Form */
            if (newTab.title === 'Strategy') {
                this.getStrategyMasterData();
                //this.retirementFormDataCollection = Array.from(this.retirementFormData);
                //this.retirementFormDataCollection = [...this.retirementFormData];
            } else if (newTab.title === 'Category') {
                this.getCategoryMasterData();
            } else if (newTab.title === 'Response Title') {
                this.getResponseTitleMasterData();
            } else if (newTab.title === 'Question Type') {
                this.getQuestionTypeMasterData();
            } else if (newTab.title === 'Strategy Benchmark') {
                this.getStrategyBenchmarkMasterData();
            } else if (newTab.title === 'Strategy Form') {
                this.getStrategyData();
            } else if (newTab.title === 'Conversations Form') {
                this.selectedStrategyTitleItem = null;
                this.selectedCategoryItem = null;
                this.strategyQueObject = {
                    "strategy_category": "",
                    "strategy_title": "",
                    "data": []
                };
                this.getCategoryMasterData();
                this.getQuestionTypeMasterData();
                this.getStrategyMasterData();
                this.getStrategyBenchmarkMasterData();
            } else if (newTab.title === 'Hubble-Grable Investor Risk Profiling') {
                this.getInvestorRiskProfiling();
            } else if (newTab.title === 'Your First Investment') {
                this.getFirstInvestmentAPI();
            } else if (newTab.title === 'Interpretation Of Results') {
                this.getInterpretationResultAPI();
            } else if (newTab.title === 'Assumptions & Asset Allocation Framework') {
                this.getAAAFrameworkAPI();
            } else if (newTab.title === 'Asset Allocation Assumptions Time Horizon') {
                this.getAAATimeHorizonAPI();
            } else if (newTab.title === 'Asset Allocation Assumptions Risk Profile') {
                this.getAAARiskProfileOfClientAPI();
            } else if (newTab.title === 'Asset Allocation Assumptions Income Generation') {
                this.getAAAIncomeGenerationAPI();
            } else if (newTab.title === 'Professionals Recommendation to Client') {
                this.getRecommendationToClientAPI();
            }
            this.isNew = false;
            this.isShow = false;
        },

        addStrategyFormDataHandler() {
            this.retirementFormData[0].data.push({
                "title": "",
                "type": "input",
                "response_list": [],
                "answer": ""
            })
        },
        addStrategyMasterDataHandler() {
            this.strategyMasterData.push({
                "strategy_title": "Retirement fund strategy"
            })
        },
        removeRowDataHandler(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.retirementFormData[0].data.splice(idx, 1);
                self.submitStrategyFormData();
            }
        },

        removeStrategyQueRowDataHandler(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.strategyQueObject.data.splice(idx, 1);
                self.submitConversationsFormData();
            }
        },
        removeFirstInvestmentData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.firstInvestmentTblData[0].data.splice(idx, 1);
                self.submitFirstInvestmentAPI();
            }
        },
        submitStrategyFormData() {
            console.log('submit data', this.retirementFormData[0]);
            let self = this;
            http.post("/frontend/strategy_columns/update", this.retirementFormData[0], function (error, response) {
                console.log(">>>> post data:", response);
                if (response.responseType === "success") {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        },
        submitStrategyMasterData() {
            console.log('submitStrategyMasterData: ', this.strategyMasterData);
            let self = this;
            if (self.editStrategyMasterData.strategy_title.trim() === "") {
                self.$toastr.error("Strategy string not blank", "", {});
            } else {
                http.post("/frontend/strategy_update/update", this.editStrategyMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getStrategyMasterData();
                    }
                    //_this.getStockHistoryCronQuery();
                    self.editStrategyMasterData = { strategy_title: "" };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        reloadRetirementFund() {
            this.getStrategyData();
            /* console.log('new', this.retirementFormData)
            console.log('old', this.retirementFormDataCollection)
            //this.retirementFormData = [...this.retirementFormDataCollection];
            let collectData = this.retirementFormDataCollection[0].data.map((item) => {
                return item;
            });
            this.retirementFormData = [{ data: [...collectData] }]; */
        }
    },
    /* validators: {
      email: function (value) {
        return Validator.value(value).required().email();
      }
    } */
    validators: {
        title: function (value) {
            return Validator.value(value).required();
        },
        type: function (value) {
            return Validator.value(value).required();
        },
        strategy_benchmark: function (value) {
            return Validator.value(value).required();
        },
    },
};
</script>
<style>
.txt-fmt {
    font-size: small;
}

.form-cs {
    border: 1px solid #c4c2c2;
    padding: 13px;
    padding-bottom: 0;
    border-radius: 7px;
    background-color: #f5faff;
}

.strategy-edit {
    background-color: #d3ebef;
    border-radius: 5px;
    margin: 1rem;
}

.v-select {
    width: 100%;
    margin-left: 10px;
}

#strategyBenchmark .v-select {
    width: 100%;
    margin-left: 0;
}

#conversationForm .v-select {
    width: 100%;
    margin-left: 0;
}

#investorRiskProfiling .v-select {
    width: 100%;
    margin-left: 0 !important;
}

.v-select .dropdown-toggle {
    background-color: white;
    padding: 0 0 6px;
}

.sel-tag-main {
    width: 100%;
    /* margin-left: 10px; */
    appearance: none;
    display: flex;
    padding: 0 0 4px;
    background: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    flex-wrap: wrap;
}

.selected-tag {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #333;
    line-height: 1.42857143;
    margin: 4px 2px 0;
    padding: 0 .25em;
    transition: opacity .25s;
}

.error {
    color: red;
    /* border: 1px solid red; */
}

.txt-area {
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

.new-cal-2 {
    max-width: 14% !important;
    min-width: 14% !important;
}

.dropdown-menu {
    font-size: small;
}

.new-tbl-cs {
    appearance: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    height: 1.5rem;
    width: 100%;
    height: 1.9rem;
    padding: 0 6px;
}

.new-tbl-aaa-cs {
    appearance: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    height: 1.5rem;
    width: 100%;
    height: 1.9rem;
    padding: 0 6px;
    margin: 3px 0 3px;
}



.table td {
    padding: 5px 7px 5px 7px;
}

.circle-btn {
    /* position: relative; */
    /* padding: 30px !important; */
    /* background-color: var(--accent); */
    border-radius: 100%;
    width: fit-content;
    border: none;
    margin-left: 0.5rem;
}

/* .pull-right{
    display: flex;
} */
</style>


// WEBPACK FOOTER //
// src/views/acl/profiling/user-profiling-form.vue